import axios from 'axios';
import { toast } from 'react-toastify';
import {
  COLLECTIONS_DELETE_UITILITY_FUNCTION_BEGIN,
  COLLECTIONS_DELETE_UITILITY_FUNCTION_SUCCESS,
  COLLECTIONS_DELETE_UITILITY_FUNCTION_FAILURE,
  COLLECTIONS_DELETE_UITILITY_FUNCTION_DISMISS_ERROR,
} from './constants';

import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';

export function deleteUitilityFunction(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_DELETE_UITILITY_FUNCTION_BEGIN,
    });
    const { projectId, collectionUuid, utilityId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.delete(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/utilties/${collectionUuid}/collection/${utilityId}`,
        header,
      );
      doRequest.then(
        (res) => {
          if (res.status === 200 && res.data) {
            dispatch({
              type: COLLECTIONS_DELETE_UITILITY_FUNCTION_SUCCESS,
              data: res.data,
              collectionUuid: collectionUuid,
            });
            Mixpanel.track('Deleted derived field');
            toast.success('Deleted Successfully !');
            resolve(res);
          } else {
            dispatch({
              type: COLLECTIONS_DELETE_UITILITY_FUNCTION_FAILURE,
              data: { error: 'Failed' },
            });
            Mixpanel.track('Failed to delete derived field');
            const errMsg = getErrorMessageFromResponse(res);
            toast.error(`Deletion failed: ${errMsg}`, {});
            reject('Failed');
          }
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_DELETE_UITILITY_FUNCTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track('Failed to delete derived field');
          const errMsg = getErrorMessageFromResponse(err.response);
          toast.error(`Deletion Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissDeleteUitilityFunctionError() {
  return {
    type: COLLECTIONS_DELETE_UITILITY_FUNCTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_DELETE_UITILITY_FUNCTION_BEGIN:
      return {
        ...state,
        deleteUitilityFunctionPending: true,
        deleteUitilityFunctionError: null,
      };

    case COLLECTIONS_DELETE_UITILITY_FUNCTION_SUCCESS:
      let projectCollections = state.projectCollections;
      let index = projectCollections.findIndex((item) => {
        return item.uuid === action.collectionUuid;
      });
      projectCollections[index].utilities = action.data;
      return {
        ...state,
        deleteUitilityFunctionPending: false,
        deleteUitilityFunctionError: null,
        projectCollections,
        selectedCollection: {
          ...state.selectedCollection,
          utilities: action.data,
        },
      };
    case COLLECTIONS_DELETE_UITILITY_FUNCTION_FAILURE:
      return {
        ...state,
        deleteUitilityFunctionPending: false,
        deleteUitilityFunctionError: action.data.error,
      };

    case COLLECTIONS_DELETE_UITILITY_FUNCTION_DISMISS_ERROR:
      return {
        ...state,
        deleteUitilityFunctionError: null,
      };

    default:
      return state;
  }
}
